import { useMsal } from "@azure/msal-react";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import routeConstants from "utils/routeConstants";

import { DesktopLink, MobileLink, ArrowCircle } from "./style";

type IrisLogoutLinkProps = {
  variant: "desktop" | "mobile";
};

const IrisLogoutLink: React.FC<IrisLogoutLinkProps> = ({
  variant,
}: IrisLogoutLinkProps) => {
  const { instance } = useMsal();
  const LinkComponent = variant === "desktop" ? DesktopLink : MobileLink;

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>): void => {
    event.preventDefault();
    instance
      .logoutRedirect({
        postLogoutRedirectUri: routeConstants.home,
      })
      .catch((error: unknown) => {
        console.error("Logout failed", error);
      });
  };

  return (
    <LinkComponent
      to={routeConstants.home}
      data-test-id="iris-logout-link"
      onClick={handleClick}
    >
      <ArrowCircle>
        <FontAwesomeIcon icon={faArrowRight} />
      </ArrowCircle>
      Logout
    </LinkComponent>
  );
};

export default IrisLogoutLink;
